import api from "./api";

const adminDocumentationApi = {
    getPaged: (params) => {
        const url = '/admin/admin-documentation/paged';
        return api.get(url, { params });
    },
    getByCode: (docCode) => {
        const url = `/admin/admin-documentation/${docCode}`;
        return api.get(url);
    },
    insUpd: (data) => {
        const url = '/admin/admin-documentation';
        return api.post(url, data);
    },
    delete: (docCode) => {
        const url = `/admin/admin-documentation/${docCode}`;
        return api.delete(url);
    }
};

export default adminDocumentationApi;
